import React, { useState } from "react";
import { useAuthContext } from "./useAuthContext";
import { timestamp } from "../../firebase-config/config";
import { useFirestore } from "./useFirestore";

const useNotification = () => {
  const [notifications, setNotifications] = useState([]);
  const { user } = useAuthContext();
  const { addDocument, deleteDocument } = useFirestore("notifications");

  // Create notification
  const createNotification = async ({
    visibleFor = "allRoles",
    category,
    heading,
    description,
    status = "active",
    link,
    lifeSpan,
    metaData = {},
  }) => {
    try {
      const notificationData = {
        createdAt: timestamp.fromDate(new Date()),
        createdBy: user?.phoneNumber || "system", // Ensure a valid creator
        visibleFor,
        category,
        heading,
        description,
        status,
        link,
        lifeSpan,
        metaData,
      };

      await addDocument(notificationData);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  // Fetch notifications with cleanup
  // const fetchNotifications = async (filters = {}) => {
  //   try {
  //     let query = projectFirestore.collection("notifications");

  //     if (filters.visibleFor) {
  //       query = query.where("visibleFor", "array-contains", filters.visibleFor);
  //     }
  //     if (filters.category) {
  //       query = query.where("category", "==", filters.category);
  //     }
  //     if (filters.status) {
  //       query = query.where("status", "==", filters.status);
  //     }

  //     query = query.orderBy("createdAt", "desc");

  //     const unsubscribe = query.onSnapshot((snapshot) => {
  //       const results = snapshot.docs.map((doc) => ({
  //         id: doc.id,
  //         ...doc.data(),
  //       }));
  //       setNotifications(results);
  //     });

  //     return unsubscribe;
  //   } catch (error) {
  //     console.error("Error fetching notifications:", error);
  //   }
  // };

  // useEffect(() => {
  //   const unsubscribe = fetchNotifications();
  //   return () => unsubscribe && unsubscribe(); // Cleanup listener
  // }, []);

  // useEffect(() => {
  //   let unsubscribe;

  //   const init = async () => {
  //     unsubscribe = await fetchNotifications(); // now we wait for it
  //   };

  //   init();

  //   return () => {
  //     if (typeof unsubscribe === "function") {
  //       unsubscribe(); // safe cleanup
  //     }
  //   };
  // }, []);

  // Update notification status (bulk updates)
  // const updateNotificationStatus = async (notificationIds, status) => {
  //   try {
  //     const batch = projectFirestore.batch();
  //     notificationIds.forEach((id) => {
  //       const docRef = projectFirestore.collection("notifications").doc(id);
  //       batch.update(docRef, { status });
  //     });

  //     await batch.commit();
  //     return { success: true };
  //   } catch (error) {
  //     return { success: false, error: error.message };
  //   }
  // };

  // Delete notification
  const deleteNotification = async (notificationId) => {
    try {
      await deleteDocument(notificationId);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  return {
    notifications,
    createNotification,
    // fetchNotifications,
    // updateNotificationStatus,
    deleteNotification,
  };
};

export default useNotification;
